import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Table from '@tables/table'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import Divider from '@material-ui/core/Divider'
import { Grid, Select, MenuItem, FormControl, InputLabel, InputAdornment, TextField } from '@material-ui/core'
import Search from '@material-ui/icons/Search'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import { PfSubPfSelect, DateSelect } from '@select'

class AddPlayerRoleDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'AddPlayerRoleDialog', options)
        }
    }

    addColumn = {
        field: 'add',
        hideTitle: true,
        render: (rowData) => {
            return (
                <Button
                    style={{ minWidth: '93px' }}
                    variant="contained"
                    color="primary"
                    className={this.props.classes.button}
                    onClick={() => {
                        this.confirmDialog.OpenDialog({
                            type: 'info',
                            msg: this.t('setRoleConfirm', {
                                player_name: rowData.player_name,
                                risk_role: this.t('RiskRole.' + this.state.riskRole),
                            }),
                            confirm: (_params) => {
                                this.confirmDialog.SetConfirmBtnDisabled(true)

                                let expired_at = undefined
                                if (this.state.riskRole === RISKMGT.RISK_ROLE_BIG_RICH) {
                                    expired_at = utils.datetimeToUnix_endOf(utils.datetimeAdd(utils.currentDatetime(), 30, 'day'), 'day')
                                }

                                utils.apiRequest(
                                    'patch',
                                    API.RISKMGT_PLAYER_RISK_INFO,
                                    {
                                        pf_account_list: [rowData.pf_account],
                                        risk_role: this.state.riskRole,
                                        expired_at,
                                    },
                                    (_data) => {
                                        if (this.props.confirmCallback) this.props.confirmCallback()
                                        this.confirmDialog.closeDialog()
                                    },
                                    (_err) => {
                                        this.confirmDialog.SetConfirmBtnDisabled(false)
                                    }
                                )
                            },
                        })
                    }}
                    disabled={rowData.risk_role === this.state.riskRole}>
                    {this.t('add')}
                </Button>
            )
        },
    }

    columnsTemplate = {
        [RISKMGT.RISK_ROLE_BIG_RICH]: [
            {
                field: 'pf_sub_pf_id',
                type: 'platform',
            },
            {
                field: 'pf_account',
            },
            {
                field: 'player_name',
            },
            {
                field: 'accumulated_rounds',
            },
            {
                field: 'accumulated_bet',
                type: 'currency',
            },
            {
                field: 'risk_role_translated',
                translate: {
                    dataKey: 'risk_role',
                    tranKey: 'RiskRole',
                },
            },
            this.addColumn,
        ],
        [RISKMGT.RISK_ROLE_BLACKLIST]: [
            {
                field: 'pf_sub_pf_id',
                type: 'platform',
            },
            {
                field: 'pf_account',
            },
            {
                field: 'player_name',
            },
            {
                field: 'accumulated_rounds',
            },
            {
                field: 'accumulated_prize',
                type: 'currency',
            },
            {
                field: 'rtp_value',
                type: 'percentage',
            },
            {
                field: 'accumulated_bet',
                type: 'currency',
            },
            {
                field: 'risk_role',
            },
            this.addColumn,
        ],
    }

    state = {
        riskRole: undefined,
        subPlatformList: {},
        dialogOpen: false,
        playRoundGt: 100,
        rtpGt: 100,
        totalBetGt: 5000000,
        columns: this.columnsTemplate[RISKMGT.RISK_ROLE_BIG_RICH],
        isLoading: false,
        searchType: 'condition',
        pfAccount: '',
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(params) {
        this.setState({ dialogOpen: true, riskRole: params.riskRole })
    }

    CloseDialog() {
        this.setState({ dialogOpen: false })
    }

    updateColumn = () => {}

    queryData = () => {
        if (this.columnsTemplate[this.state.riskRole] === undefined) {
            return
        }
        this.setState({
            columns: this.columnsTemplate[this.state.riskRole],
        })

        const queryKey = {
            [RISKMGT.RISK_ROLE_BIG_RICH]: {
                bet_range: [this.state.totalBetGt, RISKMGT.MAX_FLOAT].join(','),
            },
            [RISKMGT.RISK_ROLE_BLACKLIST]: {
                rtp_range: [this.state.rtpGt, RISKMGT.MAX_FLOAT].join(','),
                played_round_range: [this.state.playRoundGt, RISKMGT.MAX_FLOAT].join(','),
            },
        }

        const queryParam =
            this.state.searchType === 'condition'
                ? Object.assign({}, queryKey[this.state.riskRole], {
                      pf_id: this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : undefined,
                      pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : undefined,
                      during: [utils.datetimeToUnix(this.dateSelect.state.startDate), utils.datetimeToUnix(this.dateSelect.state.endDate)].join(','),
                  })
                : { pf_account: this.state.pfAccount }

        this.table.queryData(queryParam)
    }

    search_filter = () => {
        switch (this.state.riskRole) {
            case RISKMGT.RISK_ROLE_BIG_RICH:
                return (
                    <TextField
                        label={this.t('totalBetGt')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.totalBetGt}
                        onChange={(event) =>
                            this.setState({
                                totalBetGt: event.target.value,
                            })
                        }
                        className={this.props.classes.textField}
                    />
                )
            case RISKMGT.RISK_ROLE_BLACKLIST:
                return (
                    <React.Fragment>
                        <TextField
                            label={this.t('playRoundGt')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.playRoundGt}
                            onChange={(event) =>
                                this.setState({
                                    playRoundGt: event.target.value,
                                })
                            }
                            className={this.props.classes.textField}
                        />
                        <TextField
                            label={this.t('rtpGt')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.rtpGt}
                            onChange={(event) =>
                                this.setState({
                                    rtpGt: event.target.value,
                                })
                            }
                            className={this.props.classes.textField}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                        />
                    </React.Fragment>
                )
            default:
                return <React.Fragment />
        }
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} fullWidth maxWidth="xl">
                <DialogTitle>
                    {this.t('Title', {
                        risk_role: this.t('RiskRole.' + this.state.riskRole),
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl className={this.props.classes.formControl}>
                                <InputLabel>{this.t('searchType')}</InputLabel>
                                <Select
                                    value={this.state.searchType}
                                    onChange={(event) =>
                                        this.setState({
                                            searchType: event.target.value,
                                        })
                                    }>
                                    <MenuItem value="condition">{this.t('condition')}</MenuItem>
                                    <MenuItem value="account">{this.t('account')}</MenuItem>
                                </Select>
                            </FormControl>
                            {this.state.searchType === 'condition' ? (
                                <React.Fragment>
                                    <PfSubPfSelect
                                        onRef={(ref) => (this.pfSelect = ref)}
                                        options={{
                                            hideCurrency: true,
                                        }}></PfSubPfSelect>
                                    <DateSelect onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                                    <this.search_filter />
                                </React.Fragment>
                            ) : (
                                <TextField
                                    label={this.t('pfAccount')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={this.state.pfAccount}
                                    onChange={(event) =>
                                        this.setState({
                                            pfAccount: event.target.value,
                                        })
                                    }
                                    className={this.props.classes.textField}
                                />
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                className={this.props.classes.button}
                                onClick={() => {
                                    this.setState({ isLoading: true })
                                    this.queryData()
                                }}
                                disabled={this.state.isLoading}>
                                <Search className={this.props.classes.rightIcon} />
                                {this.t('search')}
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                    <Grid item xs={12}>
                        <Table
                            ownerName="AddPlayerRoleDialog"
                            columns={this.state.columns}
                            options={{ export: this.export, orderIdx: 1 }}
                            onRef={(ref) => (this.table = ref)}
                            queryDataArgs={{
                                apiPath: API.RISKMGT_PLAYER_RISK_INFO_LIST,
                                callback: () => {
                                    this.setState({ isLoading: false })
                                },
                            }}
                        />
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ dialogOpen: false })
                        }}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                </DialogActions>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </Dialog>
        )
    }
}

AddPlayerRoleDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    dataService: PropTypes.object,
    confirmCallback: PropTypes.func,
}

const styles = (theme) => ({
    formControl: {
        margin: theme.spacing(1),
        width: '150px',
    },
    textField: {
        margin: theme.spacing(1),
        width: '150px',
    },
})

export default hoc(styles)(AddPlayerRoleDialog)
